// @flow
import type { Dispatch, GetState } from '../../core/types'
import client from '../../core/feathers'
import {
  cleanMyAuctionsSet,
  clearMyCharityComm,
  clearMyCharityAuctionsComm
} from './charity/actions'
import { batch } from '../../modules/lib/batchReducer'
import { CLEAR_MYCHARITY } from './charity/constants'

export default function myCharityListeners(
  dispatch: Dispatch,
  getState: GetState
) {
  client.on('logout', () => {
    dispatch(
      batch(
        CLEAR_MYCHARITY,
        cleanMyAuctionsSet,
        clearMyCharityComm,
        clearMyCharityAuctionsComm
      )
    )
  })
}



// WEBPACK FOOTER //
// ./src/services/mycharity/listeners.js